/**
 * @fileoverview POST handler for the "/apps/catalogs/:catalog_id/filtered_sets" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsCatalogsCatalogIdFilteredSetsCacheKeys } from "./constants";
import type { PostAppsCatalogsCatalogIdFilteredSetsProps, AppsCatalogsCatalogIdFilteredSetsResult } from "./types";

export const postAppsCatalogsCatalogIdFilteredSets = reactQueryMutationAdapter(
  appsCatalogsCatalogIdFilteredSetsCacheKeys,
  ({
    catalogId,
    name,
    description,
    filters,
    resultsLimit,
    sortField,
    sortOrder,
  }: PostAppsCatalogsCatalogIdFilteredSetsProps): Promise<AppsCatalogsCatalogIdFilteredSetsResult> => {
    return fetch(
      `/apps/catalogs/${catalogId}/filtered_sets`,
      "POST",
      {
        catalog_id: catalogId,
        name,
        description,
        filters,
        results_limit: resultsLimit,
        sort_field: sortField,
        sort_order: sortOrder,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
